import { Box, BoxProps, styled } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Tooltip } from "../../components";

interface LabelProps extends BoxProps {
  tooltip?: string;
  error?: boolean;
}

export const Label = styled(
  ({ children, tooltip, error, ...props }: LabelProps) => (
    <Box
      sx={{
        color: "#171A1F",
        fontSize: "12px",
        fontWeight: 500,
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
      }}
    >
      {children}&nbsp;
      {!!tooltip && (
        <Tooltip title={tooltip}>
          <InfoOutlinedIcon
            sx={{
              fontSize: "16px",
              color: "#9CA3AF",
              cursor: "pointer",
            }}
          />
        </Tooltip>
      )}
    </Box>
  ),
)(({ theme, error }) => ({
  height: "38px",
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  justifyContent: "flex-end",
  fontWeight: 500,
  fontSize: "12px",
  lineHeight: "18px",
  letterSpacing: 0,
  color: error ? theme.palette.error.main : "#000",
  // marginRight: "16px",

  [theme.breakpoints.down("sm")]: {
    justifyContent: "flex-start",
    fontSize: 14,
    // marginBottom: 8,
    // marginTop: 12,
  },
}));

export const Row = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  padding: "4px",
  minHeight: "42px",

  // [theme.breakpoints.down("sm")]: {
  //   display: "block",
  // },
}));

export const SwitchRow = styled(Row)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
}));
